import { useTranslations } from 'next-intl';
import {
  PendingIcon,
  ProcessingIcon,
  OnHoldIcon,
  CompletedIcon,
  CancelledIcon,
  RefundedIcon,
  FailedIcon,
} from '../svg/OrderStatusIcons';

const statusConfig = {
  pending: {
    Icon: PendingIcon,
    color: '#F59E0B', // Amber-500
    bgColor: '#FEF3C7', // Amber-100
  },
  processing: {
    Icon: ProcessingIcon,
    color: '#3B82F6', // Blue-500
    bgColor: '#DBEAFE', // Blue-100
  },
  'on-hold': {
    Icon: OnHoldIcon,
    color: '#6366F1', // Indigo-500
    bgColor: '#E0E7FF', // Indigo-100
  },
  completed: {
    Icon: CompletedIcon,
    color: '#10B981', // Emerald-500
    bgColor: '#D1FAE5', // Emerald-100
  },
  cancelled: {
    Icon: CancelledIcon,
    color: '#EF4444', // Red-500
    bgColor: '#FEE2E2', // Red-100
  },
  refunded: {
    Icon: RefundedIcon,
    color: '#8B5CF6', // Violet-500
    bgColor: '#EDE9FE', // Violet-100
  },
  failed: {
    Icon: FailedIcon,
    color: '#DC2626', // Red-600
    bgColor: '#FEE2E2', // Red-100
  },
};

/* eslint-disable react/prop-types */
export default function OrderStatus({ status }) {
  const t = useTranslations('Account');
  const config = statusConfig[status] || statusConfig.pending;
  const { Icon, color, bgColor } = config;

  return (
    <div
      className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium"
      style={{ backgroundColor: bgColor, color: color }}
    >
      <Icon size="16px" color={color} />
      <span className="ms-2">{t(`order_status_${status}`)}</span>
    </div>
  );
}